import * as React from 'react'
import { ErrorBoundary } from '@/modules/shared/components/ErrorBoundary'
import { ErrorFallback } from '@/modules/shared/components/ErrorFallback'
import { AppLayoutDahboardWithNav } from '@/modules/shared/layouts/AppLayoutDahboardWithNav'
import { MyProfilePage } from './pages/MyProfilePage'
import { ProfileLayout } from './ProfileLayout'

const ProfileModuleImpl: React.FC = () => {
  return (
  
     <ErrorBoundary
          fallback={(e) => <ErrorFallback error={e.error} onRetry={e.reset} />}
        >
              <AppLayoutDahboardWithNav>
                <ErrorBoundary
                  fallback={(e) => (
                    <ErrorFallback error={e.error} onRetry={e.reset} />
                  )}
                >
                    <ProfileLayout>
                      <MyProfilePage />
                    </ProfileLayout>
                </ErrorBoundary>
              </AppLayoutDahboardWithNav>
        </ErrorBoundary>
  )
}

export const ProfileModule = ProfileModuleImpl
